export default __webpack_public_path__ + "static/media/i-1.9b3db391.jpg";